import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import { Line, Bar, Pie, Column } from "@ant-design/plots";
import {
  getGroupedCountData,
  getSalesTrendData,
  getGroupedBySourceData,
  getGroupedByIndustryData,
  getConvertedLeadsData,
} from "../../actionCreator/dashboardActionCreator";
import { getUserInfo } from "../../utils/utils";
import { getLeadStatusList } from "../../actionCreator/leadListingActionCreater";

const MarketingReport = () => {
  const dispatch = useDispatch();
  const userAccountInfo = useSelector(
    (state) => state.CommonReducer.accountInfo
  );
  const groupedCountData = useSelector(
    (state) => state.DashboardReducer.groupedCountData
  );
  const salesTrendData = useSelector(
    (state) => state.DashboardReducer.salesTrendData
  );
  const groupedSourceData = useSelector(
    (state) => state.DashboardReducer.groupedSourceData
  );
  const groupedIndustryData = useSelector(
    (state) => state.DashboardReducer.groupedIndustryData
  );
  const convertedLeadsAllData = useSelector(
    (state) => state.DashboardReducer.convertedLeadsData
  );
  const leadStatusListing = useSelector(
    (state) => state.leadListingReducer.leadStatusList
  );

  useEffect(() => {
    if (Object.keys(getUserInfo()).length) {
      dispatch(getGroupedCountData());
      dispatch(getSalesTrendData());
      dispatch(getGroupedBySourceData());
      dispatch(getGroupedByIndustryData());
      dispatch(getLeadStatusList());
      dispatch(getConvertedLeadsData());
    }
  }, [userAccountInfo]);

  let salesOrderByStatus = [];
  let convertedLeadsData =
    convertedLeadsAllData?.length > 0 ? convertedLeadsAllData : [];
  
  if (salesTrendData?.dashboardDTOS) {
    let rawData = groupedCountData?.dashboardDTOS;
    salesOrderByStatus = _.orderBy(rawData, "statusId", "asc");
  }
  let groupedIndustryData1 = [];
  let leadByIndustrySortedData = [];
  let groupedIndustryTotal = 0;
  let groupedSourceData1 = [];
  let leadBySourceDataByOrder = [];
  let groupedSourceTotal = 0;
  if (groupedIndustryData?.dashboardDTOS?.length > 0) {
    //groupedIndustryData1=groupedIndustryData.dashboardDTOS;
    groupedIndustryData?.dashboardDTOS?.forEach((record) => {
      if (record?.typeValue) {
        record.typeValue =
          record?.typeValue == "null" || record?.typeValue == ""
            ? "Others"
            : record?.typeValue;
        record.order = record?.typeValue == "Others" ? "b" : "a";
        record.countSum = Number(record.countSum);
        groupedIndustryData1.push(record);
      }
    });
    if (groupedIndustryData1) {
      leadByIndustrySortedData = _.orderBy(
        groupedIndustryData1,
        "order",
        "asc"
      );
    }
    groupedIndustryTotal = groupedIndustryData.leadGenareatedCount;
  }

  if (groupedSourceData?.dashboardDTOS?.length > 0) {
    groupedSourceData?.dashboardDTOS?.forEach((record) => {
      if (record?.typeValue) {
        record.typeValue =
          record?.typeValue == "null" || record?.typeValue == ""
            ? "Others"
            : record?.typeValue;
        record.order = record?.typeValue == "Others" ? "b" : "a";
        record.countSum = Number(record.countSum);
        groupedSourceData1.push(record);
      }
    });
    if (groupedSourceData1) {
      leadBySourceDataByOrder = _.orderBy(groupedSourceData1, "order", "asc");
    }
    groupedSourceTotal = groupedSourceData.leadGenareatedCount;
  }

  const statusMap = new Map();
  leadStatusListing.forEach((item) => {
    statusMap.set(item.id + "", item.text);
  });
  const monthNames = [
    "",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  let salesTrendWonData = [];
  let salesTrendWonDataByMonth = [];
  if (salesTrendData && salesTrendData?.dashboardDTOS) {
    salesTrendData?.dashboardDTOS?.forEach((record) => {
      record.opportunitSum =
        record?.opportunitSum && record?.opportunitSum != "null"
          ? parseFloat(record?.opportunitSum)
          : 0;
      record.month = record?.typeValue ? monthNames[record.typeValue] : "";
      record.monthNum = record?.typeValue ? parseInt(record.typeValue) : 0;
      //record.opportunitSum=(record?.opportunitSum=="null")?0:record.opportunitSum;
      record.status = statusMap.get(record.statusId);
      salesTrendWonData.push(record);
    });
    if (salesTrendWonData) {
      salesTrendWonData = _.orderBy(salesTrendWonData, "monthNum", "asc");
      salesTrendWonDataByMonth = _.map(
        _.groupBy(salesTrendWonData, "typeValue"),
        (o, month) => {
          return {
            month: month ? monthNames[month] : "",
            opportunitSum: _.sumBy(o, "opportunitSum"),
          };
        }
      );
    }
  }

  const config = {
    data: leadBySourceDataByOrder,
    angleField: "countSum",
    colorField: "typeValue",
    radius: 1,
    innerRadius: 0.6,
    label: {
      type: "inner",
      visible: true,
      autoRotate: false,
      content: "{value}",
      style: {
        textAlign: "center",
        fontSize: 14,
      },
    },
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        content: "Total\n" + groupedSourceTotal,
      },
    },
  };
  //groupedIndustryData1 +groupedIndustryData?.leadGenareatedCount
  const leadByIndustry = {
    appendPadding: 10,
    data: leadByIndustrySortedData,
    angleField: "countSum",
    colorField: "typeValue",
    radius: 1,
    innerRadius: 0.6,
    label: {
      type: "inner",
      //offset: "-50%",
      autoRotate: false,
      content: "{value}",
      style: {
        textAlign: "center",
        fontSize: 14,
      },
    },
    interactions: [
      {
        type: "element-selected",
      },
      {
        type: "element-active",
      },
    ],
    statistic: {
      title: false,
      content: {
        style: {
          whiteSpace: "pre-wrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        content: "Total\n" + groupedIndustryTotal,
      },
    },
  };

  const leadByStatus = {
    data: salesTrendWonData,
    xField: "month",
    yField: "opportunitSum",
    stackField: "status",
    seriesField: "status",
    isPercent: false,
    label: {
      position: "middle",
      content: (item) => {
        return item.opportunitSum; //.toFixed(2)
      },
      style: {
        fill: "#fff",
      },
    },
  };

  const leadTrendchart = {
    data: salesTrendWonDataByMonth, //salesTrendWonData
    xField: "month",
    yField: "opportunitSum",
    label: {
      position: "middle",
      content: (item) => {
        return ""; //item.opportunitSum.toFixed(2)
      },
    },
    tooltip: {
      formatter: (datum) => {
        return {
          name: "Opportunity",
          value: `${datum.opportunitSum}`,
        };
      },
    },
    point: {
      size: 5,
      shape: "diamond",
      style: {
        fill: "white",
        stroke: "#5B8FF9",
        lineWidth: 2,
      },
    },
    interactions: [
      {
        type: "marker-active",
      },
    ],
  };

  const chart4 = {
    data: convertedLeadsData,
    xField: "oppurtunityAmount",
    yField: "fullname",
    // seriesField: "fullname",
    // legend:{
    //   visible:true,
    // },
    meta: {
      fullname: {
        alias: "Category",
      },
      oppurtunityAmount: {
        alias: "Opportunity Amount",
      },
    },
    legend: {
      visible: true,
      position: "top",
    },
    minBarWidth: 20,
    maxBarWidth: 20,
  };

  return (
    <>
      <div id="filter" className="row mx-0 mt-4 pt-4">
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-primary shadow h-100 py-2">
            <div className="card-body">
              <div className="text-xs font-weight-bold text-primary text-uppercase mb-1">
                All New Leads
              </div>
              <div className="row mx-0 no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    {groupedCountData?.leadGenareatedCount}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="las la-filter fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-success shadow h-100 py-2">
            <div className="card-body">
              <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                Campaign Sent
              </div>
              <div className="row mx-0 no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    0.0
                  </div>
                </div>
                <div className="col-auto">
                  <i className="lab la-telegram fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-info shadow h-100 py-2">
            <div className="card-body">
              <div className="text-xs font-weight-bold text-leftinfo text-uppercase mb-1">
                Lead Generated Through Campaigns
              </div>
              <div className="row mx-0 no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="row mx-0 no-gutters align-items-center">
                    <div className="col-auto">
                      <div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">
                        0.0
                      </div>
                    </div>
                    <div className="col">
                      <div className="progress progress-sm mr-2">
                        <div
                          className="progress-bar bg-info"
                          role="progressbar"
                          aria-valuenow="50"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <i className="las la-funnel-dollar fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mx-0">
        <div className="col-xl-4 col-lg-5">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-gray-800 text-uppercase">
                Lead By Source
              </h6>
            </div>

            <div className="card-body">
              <div className="chart-pie pt-4 pb-2">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-expand">
                    <div className="" style={{ height: 220 }}>
                      {" "}
                      {<Pie {...config} />}
                    </div>
                  </div>
                  <div className="chartjs-size-monitor-shrink">
                    <div className=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-5">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-uppercase text-gray-800">
                Lead By Industry
              </h6>
            </div>
            <div className="card-body">
              <div className="chart-pie pt-4 pb-2">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-expand">
                    <div className="" style={{ height: 220 }}>
                      {<Pie {...leadByIndustry} />}
                    </div>
                  </div>
                  <div className="chartjs-size-monitor-shrink">
                    <div className=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-5">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-uppercase text-gray-800">
                Converted Leads
              </h6>
            </div>
            <div className="card-body">
              <div className="chart-pie pt-4 pb-2">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-expand">
                    <div className="" style={{ height: 220 }}>
                      <Bar {...chart4} />
                    </div>
                  </div>
                  <div className="chartjs-size-monitor-shrink">
                    <div className=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mx-0">
        <div className="col-xl-8 col-lg-7">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-gray-800 text-uppercase">
                Lead By Status
              </h6>
            </div>

            <div className="card-body">
              <div className="chart-area">
                <Column {...leadByStatus} />
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-4 col-lg-5">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-uppercase text-gray-800">
                Lead Trend
              </h6>
            </div>
            <div className="card-body">
              <div className="chart-pie pt-4 pb-2">
                <div className="chartjs-size-monitor">
                  <div className="chartjs-size-monitor-expand">
                    <div className="" style={{ height: 220 }}>
                      {<Line {...leadTrendchart} />}
                    </div>
                  </div>
                  <div className="chartjs-size-monitor-shrink">
                    <div className=""></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarketingReport;
